import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, Select, message } from 'antd';
import { CheckCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { _tip_off } from '../../store/Action';
import HTTP from '../../script/service';
import './TipOff.scss';
import CusUpload from '../cusUpload/CusUpload';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
      reasonDesc: null,
      fileList: [],
    };
  }
  //隐藏
  hideModal = () => {
    _tip_off();
    this.setState(
      {
        reason: null,
        reasonDesc: null,
        fileList: [],
      },
      () => {
        this.textareaElement.value = '';
      }
    );
  };
  //图片上传
  handleChange = ({ fileList }) => this.setState({ fileList });
  //选择原因
  onChangeReason = (e) => {
    this.setState({
      reason: e,
    });
  };
  //填写理由
  onChangeReasonDesc = (e) => {
    this.setState({
      reasonDesc: e.target.value ? e.target.value.trim() : undefined,
    });
  };
  //提交举报
  submitModal = (e) => {
    const { reason, reasonDesc, fileList } = this.state;
    const { tipOff } = this.props.base;
    if (!reason || !reasonDesc) {
      message.warning('请选择举报原因，并且填写举报理由。以便客服处理。');
      return;
    }
    let pics = [];
    fileList.forEach((item, index) => {
      if (item.response && item.response.code == 200) {
        pics.push(item.response.data.default);
      }
    });
    HTTP._report_submit({
      ...tipOff,
      reason: reason,
      reasonDesc: reasonDesc,
      pics: pics.toString(),
    }).then((res) => {
      if (res.code == 200) {
        Modal.success({
          title: '提示',
          icon: null,
          content: (
            <span style={{ fontSize: '14px' }}>
              <p
                style={{
                  fontSize: '24px',
                  color: '#ffffff',
                  lineHeight: '40px',
                }}
              >
                <CheckCircleOutlined
                  style={{
                    color: '#16dc78',
                    marginRight: '10px',
                    fontSize: '30px',
                  }}
                />
                举报成功!
              </p>
              <p>我们会尽快核实</p>
            </span>
          ),
          className: 'daidai-confirm-style',
          okText: '确定',
          centered: true,
        });
        this.hideModal();
      } else {
        message.error(res.message);
      }
    });
  };
  render() {
    const { tipOff, reportReason } = this.props.base;
    const { fileList, reason, reasonDesc } = this.state;
    const uploadButton = (
      <div className="upload-plus">
        <PlusOutlined />
      </div>
    );
    return (
      <Modal
        open={tipOff ? true : false}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title="举报"
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="750px"
        zIndex={1001}
        onCancel={this.hideModal}
      >
        <div className="tip-off-content">
          <div className="form-row">
            <label className="form-row-label">
              <em>*</em>举报原因：
            </label>
            <div className="form-row-control">
              <Select
                style={{ width: 250 }}
                classNames={{ popup: { root: 'daidai-select-dropdown' } }}
                placeholder="请选择"
                value={reason || undefined}
                onChange={this.onChangeReason}
              >
                {reportReason
                  ? reportReason.map((im, ii) => {
                      return (
                        <Select.Option key={`level-${ii}`} value={im.id}>
                          {im.name}
                        </Select.Option>
                      );
                    })
                  : null}
              </Select>
            </div>
          </div>
          <div className="form-row">
            <label className="form-row-label">
              <em>*</em>举报理由：
            </label>
            <div className="form-row-control">
              <div className="textarea">
                <textarea
                  ref={(el) => (this.textareaElement = el)}
                  placeholder="请输入举报理由"
                  maxLength="200"
                  onChange={this.onChangeReasonDesc}
                ></textarea>
                <span className="number">
                  {reasonDesc ? reasonDesc.length : 0}/200
                </span>
              </div>
            </div>
          </div>
          <div className="form-row">
            <label className="form-row-label">截图：</label>
            <div className="form-row-control">
              <div className="pp-text">
                上传图片<label>（最多4张）</label>
              </div>
              <div className="image-list">
                <CusUpload
                  size={2}
                  listType="picture-card"
                  showUploadList
                  fileList={fileList}
                  changeUpload={this.handleChange}
                >
                  {fileList.length >= 4 ? null : uploadButton}
                </CusUpload>
              </div>
            </div>
          </div>
          <div className="actions">
            <button className="daidai-btn" onClick={this.hideModal}>
              取消
            </button>
            <button className="daidai-btn-primary" onClick={this.submitModal}>
              提交
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
